import React, { useEffect, useState , useMemo, Fragment } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useUser } from '../UserContext';
import './index.css';
import jsPDF from 'jspdf';
import autoTable from "jspdf-autotable";
import logo from '../../imagens/TSTRIPAS.png';
import { NumericInput } from './numericInput'; 
import { Checkbox } from '@mui/material';

const Venda = () => {
  const navigate = useNavigate();
  const { userInfo, setUserInfo } = useUser();

  const [loadingPedidos, setLoadingPedidos] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState(null);
  const [showClienteInfo, setShowClienteInfo] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState('');
  const [paymentTerms, setPaymentTerms] = useState(['', '', '', '', '', '']);
  const [receber, setReceber] = useState([]);
  const [financeiroAtrasado, setFinanceiroAtrasado] = useState([]);
  const [listaRotas, setListaRotas] = useState([]);

  const [produtos, setProdutos] = useState([]);
  const [order, setOrder] = useState({});
  const [orderItems, setOrderItems] = useState([]);
  const [searchProduto, setSearchProduto] = useState('');
  const [tipoTripa, setTipoTripa] = useState('');
  const [tipoQualidade, setTipoQualidade] = useState('');
  const [calibre, setCalibre] = useState('');
  const [apenasComQuantidade, setApenasComQuantidade] = useState(false);

  const [showModal, setShowModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [dataEntrega, setDataEntrega] = useState('');
  const [desconto, setDesconto] = useState('');
  const [descontoBoleto, setDescontoBoleto] = useState('');
  const [taxaEntrega, setTaxaEntrega] = useState('');
  const [PRVE_OBS_PEDIDO, setPRVE_OBS_PEDIDO] = useState('');
  const [ordemCompra, setOrdemCompra] = useState('');
  const [tipoFrete, setTipoFrete] = useState('');
  const [rota, setRota] = useState('');
  const [transportadora, setTransportadora] = useState('');
  const [tipoSal, setTipoSal] = useState('');
  const [percentualSal, setPercentualSal] = useState('');

  const [abaSelecionada, setAbaSelecionada] = useState("Produtos");
  const [mixProdutos, setMixProdutos] = useState([]);

  const [orcamentosSalvos, setOrcamentosSalvos] = useState([]);
  const [showOrcamentos, setShowOrcamentos] = useState(false);
  const [contadorOrdem, setContadorOrdem] = useState(1);

  //Repedir Pedidos
  const [pedidoData, setPedidoData] = useState([]);
  const [loadingPedido, setLoadingPedido] = useState(false);
  const [abaInfoCliente, setAbaInfoCliente] = useState('financeiro');

  // Itens do pedido
  const [itensPedido, setItensPedido] = useState([]);
  const [nfeSelecionada, setNfeSelecionada] = useState(null);
  const [loadingItens, setLoadingItens] = useState(false);

  // 🆕 Novos estados para controle de tabelas de preço
  const [tabelasPreco, setTabelasPreco] = useState([]); // Array com todas as tabelas vindas da API
  const [infoTabelaProduto, setInfoTabelaProduto] = useState({}); // Info de tabela aplicada por produto

  //envio de documentos
  const [files, setFiles] = useState([]);
  const [previews, setPreviews] = useState([]);
  const [message, setMessage] = useState('');

  const [inputKey, setInputKey] = useState(0);

  const [etapa, setEtapa] = useState(null); // null | 'salvando' | 'cadastrado' | 'enviando' | 'concluido' | 'erro'
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

  // 🆕 Estado para controlar timers de validação (debounce)
  const [validacaoTimers, setValidacaoTimers] = useState({});

  const cacheBuster = new Date().toISOString().slice(0, 10);

  const aceitaOutraMedida = (dados) => dados?.aceitaOutraMedida ?? true;

  useEffect(() => {
    //console.log("selectedCliente:", selectedCliente);
    //console.log("searchTerm:", searchTerm);
  }, [selectedCliente, searchTerm]);

  // Redireciona se não estiver logado ou fora do horário
  useEffect(() => {
    if (!userInfo?.username) {
      localStorage.removeItem('userInfo');
      navigate('/');
      return;
    }
  }, [userInfo, navigate]);

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (selectedCliente || (orderItems && orderItems.length > 0)) {
        e.preventDefault();
        e.returnValue = '';
        return '';
      }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [selectedCliente, orderItems]);

  useEffect(() => {
    const formaVista = ['DINHEIRO', 'PIX', 'DEBITO'];
    const pm = (paymentMethod || '').toUpperCase();

    if (formaVista.includes(pm)) {
      setPaymentTerms(['', '', '', '', '', '']);
      return;
    }

    const prazoStr = selectedCliente?.prazo || '';
    if (prazoStr) {
      const prazosArray = prazoStr.split(',').map((p) => p.trim()).slice(0, 6);
      while (prazosArray.length < 6) prazosArray.push('');
      setPaymentTerms(prazosArray);
    } else {
      setPaymentTerms(['', '', '', '', '', '']);
    }
  }, [paymentMethod, selectedCliente]);

  const credentials = btoa(`${userInfo.alias};${userInfo.venLogin}:${userInfo.venSenha}`);

  // Busca clientes
  useEffect(() => {
    const fetchClientes = async () => {
      try {
        setLoadingPedidos(true);
        const res = await fetch(`${userInfo.url}/cliente/WenAPP/vendedor/${userInfo.ven_id}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        });
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          setClientes(json);
        } catch (e) {
          console.error('Erro ao converter clientes para JSON:', e);
        }
      } catch (err) {
        console.error('Erro ao buscar clientes:', err);
      } finally {
        setLoadingPedidos(false);
      }
    };

    fetchClientes();
  }, [userInfo, credentials]);

  // Busca produtos v2
  useEffect(() => {
    const fetchProdutos = async () => {
      try {
        const res = await fetch(`${userInfo.url}/produto/v2`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        });
        const text = await res.text();
        try {
          const json = JSON.parse(text);
          // 🛡️ Proteção: garante array (cobre caso de {produtos:[...]} também)
          const lista = Array.isArray(json)
            ? json
            : Array.isArray(json?.produtos)
            ? json.produtos
            : [];
          setProdutos(lista);
          //console.log('Resposta produtos:', text);
        } catch (e) {
          console.error('Erro ao converter produtos para JSON:', e);
          setProdutos([]);
        }
      } catch (err) {
        console.error('Erro ao buscar produtos:', err);
        setProdutos([]);
      }
    };

    fetchProdutos();
  }, [userInfo, credentials]);

  // 🆕 Busca tabelas de preço do endpoint
  useEffect(() => {
    if (!userInfo?.alias || !credentials) return;

    const carregarTabelasPreco = async () => {
      try {
        //console.log('🔍 Buscando tabelas de preço...');
        //console.log('URL:', `${userInfo.url}/tabelas`);

        const response = await fetch(`${userInfo.url}/tabelas`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });

        console.log('📡 Status da resposta:', response.status);

        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();
        //console.log('📊 Tabelas carregadas:', data);
        
        setTabelasPreco(data);

      } catch (error) {
        console.error('❌ Erro ao carregar tabelas:', error);
      }
    };

    carregarTabelasPreco();
  }, [userInfo, credentials]);

  // 🆕 Busca lista de rotas disponiveis do endpoint
  useEffect(() => {
    if (!userInfo?.alias || !credentials) return;

    const listaRotasCliente = async () => {
      try {
        //console.log('🔍 Buscando tabelas de preço...');
        //console.log('URL:', `${userInfo.url}/tabelas`);

        const response = await fetch(`${userInfo.url}/rotacliente`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          }
        });

        console.log('📡 Status da resposta:', response.status);

        if (!response.ok) {
          throw new Error(`Erro HTTP: ${response.status}`);
        }

        const data = await response.json();
        console.log('Lista de Rotas carregada:', data);
        
        setListaRotas(data);

      } catch (error) {
        console.error('❌ Erro ao carregar tabelas:', error);
      }
    };

    listaRotasCliente();
  }, [userInfo, credentials]);

  // Busca o mix
  useEffect(() => {
    if (selectedCliente?.cliId && Array.isArray(produtos)) {
      fetch(`${userInfo.url}/cliente/WenAPP/mixvenda/${selectedCliente.cliId}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        },
      })
        .then(res => res.json())
        .then(dataMix => {
          if (!Array.isArray(dataMix)) {
            setMixProdutos([]);
            return;
          }
          const mixComDetalhes = dataMix.map(mixItem => {
            const produto = produtos.find(p => p.tabId === mixItem.tabId);
            return {
              ...produto,
              qtdPeriodo: mixItem.qtdPeriodo,
              vlrUltVenda: mixItem.vlrUltVenda
            };
          }).filter(item => item.tabId); // remove itens sem produto correspondente

          setMixProdutos(mixComDetalhes);
        })
        .catch(err => {
          console.error("Erro ao buscar mix:", err);
          setMixProdutos([]);
        });
    }
  }, [abaSelecionada, produtos, userInfo, selectedCliente, credentials]);

  // Filtra clientes para autocomplete
  const filteredClientes = clientes.filter((c) => {
    const termo = searchTerm.toLowerCase();

    return (
      c.cliId?.toString().includes(termo) ||
      c.colNome?.toLowerCase().includes(termo) ||
      c.colFantasia?.toLowerCase().includes(termo) ||
      c.colCnpjCpf?.toLowerCase().includes(termo)
    );
  });

  const handleSelectCliente = (cliente) => {
    console.log("Cliente selecionado:", cliente);
    setSelectedCliente(cliente);
    setOrder({});
    setOrderItems([]);
    setInfoTabelaProduto({});
    setPaymentMethod(cliente.pagDescricao);
    setSearchTerm(cliente.colNome)
    setShowSuggestions(false);

    if (userInfo.bloqFinanceiro === 'T' && cliente.vencido === 'T') {
      alert('Cliente com pendências financeiras. Operação bloqueada.');
    } else if (cliente.vencido === 'T') {
      alert('Cliente com pendências financeiras.');
    }
  };

  useEffect(() => {
    if (selectedCliente?.cliId) {
      fetch(`${userInfo.url}/receber/cliente/${selectedCliente.cliId}`, {
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
        })
        .then(res => res.json())
        .then(data => {
          setFinanceiroAtrasado(data);
        })
        .catch(err => console.error(err));
    }
  }, [userInfo, selectedCliente, credentials]);

  const handleTermChange = (index, value) => {
    const updated = [...paymentTerms];
    updated[index] = value;
    setPaymentTerms(updated);
  };

  //Fução de Repetir pedido
  const buscarPedidosCliente = async (cliId) => {
    setLoadingPedido(true);
    try {
      const res = await fetch(`${userInfo.url}/nfe`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
          'venId': userInfo.ven_id,
          'cliId': cliId,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setPedidoData(json);
    } catch (err) {
      console.error('Erro ao buscar dados do pedido:', err);
    } finally {
      setLoadingPedido(false);
    }
  };

  // Função renomeada para não conflitar com o estado "itensPedido"
  const buscarItensPedido = async (nfeId) => {
    // Se já está aberto, fecha
    if (nfeSelecionada === nfeId) {
      setNfeSelecionada(null);
      setItensPedido([]);
      return;
    }

    setNfeSelecionada(nfeId);
    setItensPedido([]);
    setLoadingItens(true);

    try {
      const res = await fetch(`${userInfo.url}/itemnfe/pedido/${nfeId}`, {
        headers: {
          'Content-Type': 'application/json',
          'empresa': userInfo.alias,
          'Authorization': `Basic ${credentials}`,
        }
      });

      const text = await res.text();
      const safeText = text.replace(/\u00A0/g, ' ').trim();
      const json = JSON.parse(safeText);

      setItensPedido(json);
    } catch (err) {
      console.error('Erro ao buscar itens do Pedido:', err);
    } finally {
      setLoadingItens(false);
    }
  };

  const handleTermBlur = (index, value) => {
    for (let i = 0; i < paymentTerms.length; i++) {
      const val = Number(paymentTerms[i]);
      
      if ((paymentMethod === "BOLETO" || paymentMethod === "CARTEIRA") && i === 0 && val <= 0) {
        //alert("Para BOLETO ou CARTEIRA, o primeiro prazo deve ser maior que 0 dias!");
        const updated = [...paymentTerms];
          updated[index] = '';
          setPaymentTerms(updated);
        return;
      };
      
      if (i > 0 && paymentTerms[i] !== '' && paymentTerms[i] != null) {
        const valorAnterior = Number(paymentTerms[i - 1]);
        if (paymentTerms[i - 1] !== '' && paymentTerms[i - 1] != null && val <= valorAnterior) {
          alert("O prazo da parcela deve ser maior que o anterior!");
          return;
        }
      }
    }
  };

  // 🆕 Função para calcular faixa de preço válido (±20% menor, +30% maior)
  const calcularFaixaPreco = (tabId) => {
    const tabelasProduto = tabelasPreco.filter(t => t.tabId === tabId);

    if (!tabelasProduto || tabelasProduto.length === 0) {
      return { min: 0, max: Infinity };
    }

    // Pegar todos os preços das comissões
    const todosPrecos = [];
    tabelasProduto.forEach(tab => {
      if (tab.comissao2) todosPrecos.push(tab.comissao2);
      if (tab.comissao3) todosPrecos.push(tab.comissao3);
      if (tab.comissao4) todosPrecos.push(tab.comissao4);
      if (tab.comissao5) todosPrecos.push(tab.comissao5);
    });

    if (todosPrecos.length === 0) {
      return { min: 0, max: Infinity };
    }

    const menorPreco = Math.min(...todosPrecos);
    const maiorPreco = Math.max(...todosPrecos);

    // Calcular limites: -20% do menor e +30% do maior
    const precoMinimo = menorPreco * 1; // 20% abaixo do menor
    const precoMaximo = maiorPreco * 1; // 30% acima do maior

    return { min: precoMinimo, max: precoMaximo };
  };

  // 🆕 Função para identificar tabela e comissão baseada no preço digitado
  const identificarTabelaEComissao = (tabId, preco) => {
    const tabelasProduto = tabelasPreco.filter(t => t.tabId === tabId);

    if (!tabelasProduto || tabelasProduto.length === 0) {
      return null;
    }

    let melhorMatch = null;
    let menorDiferenca = Infinity;

    tabelasProduto.forEach(tab => {
      const opcoes = [
        { nivel: 2, preco: tab.comissao2, comissao: tab.percomissao2 },
        { nivel: 3, preco: tab.comissao3, comissao: tab.percomissao3 },
        { nivel: 4, preco: tab.comissao4, comissao: tab.percomissao4 },
        { nivel: 5, preco: tab.comissao5, comissao: tab.percomissao5 },
      ];

      opcoes.forEach(op => {
        if (op.preco) {
          const diferenca = Math.abs(op.preco - preco);
          if (diferenca < menorDiferenca) {
            menorDiferenca = diferenca;
            melhorMatch = {
              tabDescricao: tab.tabDescricao,
              nivel: op.nivel,
              precoTabela: op.preco,
              comissao: op.comissao
            };
          }
        }
      });
    });

    return melhorMatch;
  };

  // 🆕 Validação de preço (sem alert, apenas retorna resultado)
  const validarPreco = (tabId, preco) => {
    const faixa = calcularFaixaPreco(tabId);

    if (preco < faixa.min) {
      return {
        valido: false,
        mensagem: `⚠️ Preço abaixo do permitido! Mínimo: R$ ${faixa.min.toFixed(2)}`
      };
    }

    if (preco > faixa.max) {
      return {
        valido: false,
        mensagem: `⚠️ Preço acima do permitido! Máximo: R$ ${faixa.max.toFixed(2)}`
      };
    }

    const info = identificarTabelaEComissao(tabId, preco);
    
    if (!info) {
      return {
        valido: true,
        mensagem: ""
      };
    }

    return {
      valido: true,
      mensagem: `✅ Tabela: ${info.tabDescricao} | Comissão: ${info.comissao}%`
    };
  };

  // 🆕 Função para validar com delay (debounce)
  const validarPrecoComDelay = (tabId, preco) => {
    // Limpar timer anterior se existir
    if (validacaoTimers[tabId]) {
      clearTimeout(validacaoTimers[tabId]);
    }

    // Criar novo timer
    const timer = setTimeout(() => {
      const validacao = validarPreco(tabId, preco);

      setInfoTabelaProduto(prev => ({
        ...prev,
        [tabId]: validacao.mensagem
      }));
    }, 800); // 800ms de delay (ajuste conforme necessário)

    // Salvar referência do timer
    setValidacaoTimers(prev => ({
      ...prev,
      [tabId]: timer
    }));
  };

  const handleQuantityChange = (tabId, value) => {
    let quantidade = parseFloat(value) || 0;
    const prod = produtos.find((p) => p.tabId === tabId);

    if (userInfo.controlaEstoque === 'T' && prod && quantidade > prod.proQtdEstoque) {
      quantidade = prod.proQtdEstoque;
    }

    setOrder((prev) => {
      const itemAtual = prev[tabId] || {};
      const precoAtual = itemAtual.preco ?? prod.vlrVenda;

      const tinhaQuantidade = itemAtual.quantidade > 0;
      const temQuantidadeAgora = quantidade > 0;

      let novaOrdem = itemAtual.ordem;
      if (!tinhaQuantidade && temQuantidadeAgora) {
        novaOrdem = contadorOrdem;
        setContadorOrdem(c => c + 1);
      }

      if (temQuantidadeAgora) {
        validarPrecoComDelay(tabId, precoAtual);
      }

      return {
        ...prev,
        [tabId]: {
          ...itemAtual,
          quantidade,
          preco: precoAtual,
          ordem: novaOrdem,
          aceitaOutraMedida: itemAtual.aceitaOutraMedida ?? true, // materializa o padrão
        },
      };
    });
  };

  // 🆕 Handler de mudança de preço COM DELAY
  const handlePriceChange = (tabId, val) => {
    const preco = parseFloat(val) || 0;

    setOrder((prev) => ({
      ...prev,
      [tabId]: {
        ...(prev[tabId] || {}),
        preco: preco
      },
    }));

    // 🆕 Validar com delay
    validarPrecoComDelay(tabId, preco);

  };

  const calcularTotalPedido = () => {
    return Object.entries(order).reduce((acc, [tabId, data]) => {
      const prod = produtos.find((p) => p.tabId === parseInt(tabId));
      if (!prod) return acc;
      const preco = data.preco ?? prod.vlrVenda;
      const qtd = data.quantidade ?? 0;
      return acc + preco * qtd;
    }, 0);
  };

  //altera o preço do modal e a quantidade do modal na lista
  const handleModalItemChange = (idx, campo, valor) => {
    setOrderItems(prev =>
      prev.map((item, index) => {
        if (index !== idx) return item;

        const atualizado = { ...item, [campo]: valor };

        // Se alterou preço, também atualiza o líquido
        if (campo === 'IPRV_VLR_PRODUTO') {
          atualizado.IPRV_VLR_LIQUIDO = valor;
        }

        // 🆕 Sincroniza com o "order" (lista de produtos) usando o proId do item
        setOrder(prevOrder => ({
          ...prevOrder,
          [item.TAB_ID]: {
            ...prevOrder[item.TAB_ID],
            quantidade: campo === 'IPRV_QTD_PRODUTO' ? valor : prevOrder[item.TAB_ID]?.quantidade,
            preco: campo === 'IPRV_VLR_PRODUTO' ? valor : prevOrder[item.TAB_ID]?.preco,
          }
        }));

        return atualizado;
      })
    );
  };

  const calcularTotalModal = () =>
  orderItems.reduce((acc, i) => acc + i.IPRV_QTD_PRODUTO * i.IPRV_VLR_PRODUTO, 0);

  const confirmarPedido = () => {
    if (userInfo.bloqFinanceiro === 'T' && selectedCliente?.vencido === 'T') {
      alert('Cliente com pendências financeiras. Pedido bloqueado.');
      return;
    }

    if (!selectedCliente) {
      alert('Selecione um cliente!');
      return;
    }

    if (!paymentMethod || paymentMethod.trim() === "") {
      alert('Selecione uma forma de pagamento!');
      return;
    }

    const total = calcularTotalPedido();

    const formaVista = ['DINHEIRO', 'PIX', 'DEBITO', 'CREDITO'];

    const limiteDisponivelAjustado = (selectedCliente.limiteDisponivel ?? 0);

    if (
      userInfo.limiteCredito === 'T' &&
      !formaVista.includes(paymentMethod.toUpperCase()) &&
      total > limiteDisponivelAjustado
    ) {
      alert(
        `Limite de crédito excedido!\nLimite disponível ajustado: R$ ${limiteDisponivelAjustado.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}\nTotal do pedido: R$ ${total.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}`
      );
      return;
   }

   if (
      userInfo.limiteCredito === 'F' &&
      !formaVista.includes(paymentMethod.toUpperCase()) &&
      total > limiteDisponivelAjustado
    ) {
      alert(
        `Limite de crédito excedido!\n\nLimite disponível ajustado: R$ ${limiteDisponivelAjustado.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}\nTotal do pedido: R$ ${total.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}`
      );
   }

   for (let i = 0; i < paymentTerms.length; i++) {
    const val = Number(paymentTerms[i]);  
    
    if ((paymentMethod === "BOLETO" || paymentMethod === "CARTEIRA") && i === 0 && val <= 0) {
      alert("Para BOLETO ou CARTEIRA, o primeiro prazo deve ser maior que 0 dias!");
      return;
    }
    
    if (i > 0 && paymentTerms[i] !== '' && paymentTerms[i] != null) {
      const valorAnterior = Number(paymentTerms[i - 1]);
      if (paymentTerms[i - 1] !== '' && paymentTerms[i - 1] != null && val <= valorAnterior) {
        alert("O prazo da parcela deve ser maior que o anterior!");
        return;
      }
    }

    if (userInfo.limitarPrazoBoleto === 'T' && 
        (paymentMethod === "BOLETO" || paymentMethod === "CARTEIRA") &&
        val > Number(selectedCliente.prazoMaximo)) {
        alert(`Prazo da parcela ${i + 1} (${val} dias) é MAIOR que o permitido no Cliente (${Number(selectedCliente.prazoMaximo)} dias)!`);
        return;
      }  
    }

    if (userInfo.descontoFinanceiro === "T" && descontoBoleto !== '' && userInfo.venFlexDisponivel < (descontoBoleto || 0)) {
      alert(`Desconto solicitado (${Number(descontoBoleto || 0).toFixed(2)}) é maior que o Flex disponível (${userInfo.venFlexDisponivel.toFixed(2)})!`);
      return;
    }

    if (produtos.length === 0) {
      alert('Nenhum produto adicionado.');
      return;
    }

    for (const [id, data] of Object.entries(order)) {
      if (data.quantidade > 0) {
        const produto = produtos.find(p => p.proId === parseInt(id));
        if (produto && data.preco <= 0) {
          alert(`Valor de venda do produto ${produto.proDescricao} deve ser maior que zero.`);
          return;
        }
      }
    }

    if (tipoFrete === '') {
      alert('Selecione um Tipo de frete!');
      return;
    }

    if ((tipoFrete === 'PAGO' || tipoFrete === 'A PAGAR') && transportadora === '') {
      alert('Digite o nome da Transpostadora!')
      return;
    }

    if (tipoFrete === 'PROPRIO REMETENTE' && rota === 0) {
     alert('Selecione uma Data de entraga para sua Rota!');
     return;
    }

    if (tipoSal === '') {
      alert('Selecione um Tipo de Sal para este pedido!');
      return;
    }

    if (tipoSal === 'FINO' && percentualSal === '' ) {
      alert('Selecione qual o % de sala ser enviado!');
      return;
    }

    if (!dataEntrega || dataEntrega.trim() === "") {
      alert('Data de entrega é obrigatória!');
      return;
    }

    const ITEM_NFE = Object.entries(order)
      .map(([id, data]) => {
        const prod = produtos.find((p) => p.tabId === parseInt(id));
        if (prod && data.quantidade > 0) {
          const item = {
            PRO_ID: 0,
            descricao: prod.descricao,
            IPRV_QTD_PRODUTO: data.quantidade,
            IPRV_UNIDADE: data.embalagem || prod.embUnidade,
            IPRV_VLR_PRODUTO: data.preco ?? prod.vlrVenda,
            IPRV_VLR_LIQUIDO: data.preco ?? prod.vlrVenda,
            NCM_ID: 1,
            IPRV_ORDEM: data.ordem,
            IPRV_VLR_VENDA: prod.vlrVenda,
            IPRV_VLR_CUSTO: 0,
            IPRV_VLR_COMPRA: 0,
            IPRV_PER_COMISSAO: 0,
            ordem: data.ordem,
            IPRV_DESC_COMPLEMENTAR: data.descricaoComplementar || '',
            IPRV_OUTRA_MEDIDA: aceitaOutraMedida(data) ? 'T' : 'F',
            TAB_ID: prod.tabId,
          };
                    return item;
        }
        return null;
      })
      .filter(Boolean)
      .sort((a, b) => (a.ordem || 999) - (b.ordem || 999));

    let prazos = paymentTerms.filter((p) => p && !isNaN(p));

    if (formaVista.includes(paymentMethod.toUpperCase()) && prazos.length === 0) {
      prazos = ['0'];
    }

    const totalVenda = ITEM_NFE.reduce(
      (acc, i) => acc + i.IPRV_QTD_PRODUTO * i.IPRV_VLR_PRODUTO,
      0
    );

    const valorParcela = Number((totalVenda / prazos.length).toFixed(2));
    const valorDescontoBoleto = Number((descontoBoleto  / prazos.length).toFixed(2));

    const RECEBER = prazos.map((dias) => {
      const dataVenc = (new Date(dataEntrega && dataEntrega.trim() !== ''
          ? dataEntrega
          : new Date().toISOString().split('T')[0]) || new Date());
      dataVenc.setDate(dataVenc.getDate() + parseInt(dias, 10));

      return {
        CLI_ID: selectedCliente.cliId,
        VEN_ID: userInfo.ven_id,
        CRE_PAGAMENTO: paymentMethod,
        CRE_DTA_VENCIMENTO: dataVenc.toISOString().split('T')[0],
        CRE_VLR_RECEBER: valorParcela,
        CRE_STATUS: 'Em Aberto',
        CRE_VLR_DESCONTO: valorDescontoBoleto,
        CRE_TOT_DIFERENCA: Number((valorParcela - valorDescontoBoleto).toFixed(2)),
        CRE_OCULTAR: 'T',
      };
    });

    if (ITEM_NFE.length === 0) {
      alert('Nenhum produto adicionado.');
      return;
    }

    setOrderItems(ITEM_NFE);
    setReceber(RECEBER);
    setShowModal(true);
  };

  const enviarPedido = async () => {
    if (isSubmitting) return;
    setIsSubmitting(true);
    setEtapa('salvando');

    const obsPedido = [
      PRVE_OBS_PEDIDO,
      descontoBoleto && parseFloat(descontoBoleto) > 0
        ? `Desconto no boleto: R$ ${parseFloat(descontoBoleto).toFixed(2)}`
        : ''
    ]
    .filter(Boolean)
    .join(' | '); 

    const payload = {
      CLI_ID: selectedCliente.cliId,
      VEN_ID: userInfo.ven_id,
      PRVE_DTA_CADASTRO: new Date().toISOString().split('T')[0],
      PRVE_DTA_ENTREGA:
        dataEntrega && dataEntrega.trim() !== ''
          ? dataEntrega
          : new Date().toISOString().split('T')[0],
      PRVE_TOT_MERCADORIA: parseFloat(calcularTotalPedido()),
      PRVE_TOT_NOTA: (calcularTotalPedido() - Number(desconto || 0) + Number(taxaEntrega || 0)).toFixed(2),
      PRVE_TOT_DESCONTO: parseFloat(desconto) || 0,
      PRVE_TOT_FRETE: parseFloat(taxaEntrega) || 0,
      PRVE_OBS_PEDIDO: obsPedido + ` - Forma de pagamento: ${paymentMethod} - Prazos: ${paymentTerms.filter(p => p).join(', ')} dias`,
      PRVE_TIPO_PEDIDO: 'VENDA',
      PRVE_STATUS: 'Aguardando',
      GEC_ID: 1,
      TAB_ID: null,
      PRVE_ORDEM_COMPRA: ordemCompra,
      PRVE_TIPO_FRETE: tipoFrete,
      TRA_ID: 1,
      STA_ID: 1,
      PRVE_TRA_NOME: transportadora,
      ROTA_ID: Number(rota),
      PRVE_ORDEM_INTERNA: `${tipoSal} - ${percentualSal || 0}%`,
      ITEM_PREVENDA: orderItems,
      RECEBER: receber,
    };

    try {
      const res = await fetch(`${userInfo.url}/prevenda`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json', 
            empresa: userInfo.alias },
          body: JSON.stringify(payload),
        }
      );

    const textRetorno = await res.text();
    const safeText = textRetorno.replace(/\u00A0/g, ' ').trim();
    let data = null;
    try {
      data = safeText ? JSON.parse(safeText) : null;
    } catch {
      data = null;
    }

    if (res.ok) {
      setEtapa('cadastrado');
      await sleep(1500);

      const novoPedidoId = data?.prve_id;

      if (files.length) {
        if (!novoPedidoId) {
          alert('Pedido cadastrado, mas não foi possível obter o número para anexar os arquivos.');
        } else {
          setEtapa('enviando');
          const ok = await envioArquivo(novoPedidoId);
          if (!ok) {
            alert('Pedido cadastrado, mas alguns arquivos falharam.');
          }
        }
      }

      setEtapa('concluido');
      await sleep(1500);
      setEtapa(null);

      // Falha aqui não deve indicar erro no pedido
      try {
        await atualizarFlex();
      } catch (err) {
        console.error('Erro ao atualizar flex:', err);
      }

      /*alert('Pedido enviado com sucesso!');*/
      navigate('/menu');
      return;
    }

    setEtapa('erro');
    if (res.status === 426) {
      const produtosComProblema =
        data?.map((p) => `${p.PRO_DESCRICAO} (Saldo: ${p.SALDO_DISPONIVEL})`).join('\n')
        || 'Erro de estoque';
      alert(`Não foi possível enviar o pedido. Estoque insuficiente nos produtos:\n${produtosComProblema}`);
    } else {
      alert('Erro ao enviar pedido.');
      console.log('Payload:', payload);
      console.log('Resposta do servidor:', data);
    }
    await sleep(2000);
    setEtapa(null);
  } catch (err) {
    console.error('Erro ao enviar pedido:', err);
    setEtapa('erro');
    await sleep(2000);
    setEtapa(null);
    alert('Falha na conexão com o servidor.');
  } finally {
    setIsSubmitting(false);
  }
};  

  const atualizarFlex = async () => {
  const res = await fetch(`${userInfo.url}/login/v1`, {
    headers: {
      'Content-Type': 'application/json',
      'empresa': userInfo.alias,
      'Authorization': `Basic ${credentials}`,
    },
  });

  const novoUser = await res.json();
  setUserInfo(prev => ({
    ...prev,
    venFlexDisponivel: novoUser[0].venFlexDisponivel,
  }));
  };

  const safeSearch = (searchProduto || '').toLowerCase();
  const produtosFiltrados = produtos.filter(
    (p) =>
      (p.proDescricao?.toLowerCase().includes(safeSearch) || false) ||
      String(p.proCodInterno || '').includes(safeSearch) ||
      (p.marDescricao?.toLowerCase().includes(safeSearch) || false)
  );

const gerarPDF = () => {
  const pdf = new jsPDF();
  const pageWidth = pdf.internal.pageSize.getWidth();

  const logoUrl = `https://www.tstripas.com.br/wp-content/uploads/2024/08/TS-TRIPAS-1-Logos.png?v=${cacheBuster}`;

  const carregarImagem = (url) => {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = () => resolve(img);
      img.onerror = reject;
      img.src = url;
    });
  };

  const hoje = new Date().toLocaleDateString("pt-BR");

  const montarPDF = (logoImg) => {
    // ===== CABEÇALHO =====
    if (logoImg) {
      pdf.addImage(logoImg, "BMP", 10, 8, 30, 20);
    }

    pdf.setFontSize(18);
    pdf.setTextColor(41, 128, 185);
    pdf.setFont(undefined, "bold");
    pdf.text("Orçamento", pageWidth / 2, 18, { align: "center" });

    pdf.setFontSize(10);
    pdf.setTextColor(100);
    pdf.setFont(undefined, "normal");
    pdf.text(`Data: ${hoje}`, pageWidth - 10, 15, { align: "right" });

    pdf.setDrawColor(41, 128, 185);
    pdf.setLineWidth(0.5);
    pdf.line(10, 30, pageWidth - 10, 30);

    // ===== DADOS DO CLIENTE / PAGAMENTO =====
    let y = 38;
    pdf.setFontSize(11);
    pdf.setTextColor(0);
    pdf.setFont(undefined, "bold");
    pdf.text("Dados do Cliente", 10, y);
    pdf.setFont(undefined, "normal");
    pdf.text(`${selectedCliente?.colFantasia || ""}`, 60, y);

    y += 7;
    pdf.setFont(undefined, "bold");
    pdf.text("Pagamento", 10, y);
    pdf.setFont(undefined, "normal");
    pdf.text(`${paymentMethod || ""}`, 60, y);

    const parcelasValidas = paymentTerms.filter((d) => d !== undefined && d !== null && d !== '');

    y += 7;
    pdf.setFont(undefined, "bold");
    pdf.text("Parcelas", 10, y);
    pdf.setFont(undefined, "normal");
    const textoParcelas = parcelasValidas.length
      ? parcelasValidas.map((d) => `${d} dias`).join(" , ")
      : "-";
    pdf.text(textoParcelas, 60, y);

    y += 9;
    pdf.setDrawColor(220);
    pdf.line(10, y, pageWidth - 10, y);
    y += 8;

    // ===== TABELA DE PRODUTOS =====
    const tableColumn = ["Produto", "Embalagem", "Qtd", "Unid.", "Vlr Unit.", "Total"];
    const tableRows = orderItems
      .sort((a, b) => a.ordem - b.ordem)
      .map((i) => {
        const qtd = i.IPRV_QTD_PRODUTO || 0;
        const vlr = i.IPRV_VLR_PRODUTO || 0;
        return [
          `${i.descricao}${i.IPRV_DESC_COMPLEMENTAR ? " " + i.IPRV_DESC_COMPLEMENTAR : ""}`,
          i.IPRV_EMBALAGEM || "-",
          qtd,
          i.IPRV_UNIDADE || "",
          `R$ ${vlr.toFixed(2)}`,
          `R$ ${(qtd * vlr).toFixed(2)}`,
        ];
      });

    autoTable(pdf, {
      head: [tableColumn],
      body: tableRows,
      startY: y,
      styles: { fontSize: 9, cellPadding: 3 },
      headStyles: { fillColor: [41, 128, 185], textColor: 255, fontStyle: "bold" },
      alternateRowStyles: { fillColor: [245, 249, 252] },
      theme: "grid",
      margin: { left: 10, right: 10 },
    });

    // ===== TOTAIS =====
    const finalY = pdf.lastAutoTable.finalY + 8;
    const subTotal = calcularTotalModal();
    const totalPedido = subTotal - Number(desconto || 0) + Number(taxaEntrega || 0);

    let yTotais = finalY;
    const xLabel = pageWidth - 90;
    const xValor = pageWidth - 10;

    pdf.setFontSize(10);
    pdf.setFont(undefined, "normal");
    pdf.text("Sub Total:", xLabel, yTotais);
    pdf.text(`R$ ${subTotal.toFixed(2)}`, xValor, yTotais, { align: "right" });

    if (userInfo.descontoPedido === "T") {
      yTotais += 6;
      pdf.text("Desconto Pedido:", xLabel, yTotais);
      pdf.text(`R$ ${(parseFloat(desconto) || 0).toFixed(2)}`, xValor, yTotais, { align: "right" });
    }

    if (userInfo.descontoFinanceiro === "T") {
      yTotais += 6;
      pdf.text("Desconto Boleto:", xLabel, yTotais);
      pdf.text(`R$ ${(parseFloat(descontoBoleto) || 0).toFixed(2)}`, xValor, yTotais, { align: "right" });
    }

    if (userInfo.taxaEntrega === "T") {
      yTotais += 6;
      pdf.text("Taxa Entrega:", xLabel, yTotais);
      pdf.text(`R$ ${(parseFloat(taxaEntrega) || 0).toFixed(2)}`, xValor, yTotais, { align: "right" });
    }

    yTotais += 4;
    pdf.setDrawColor(41, 128, 185);
    pdf.line(xLabel, yTotais, xValor, yTotais);

    yTotais += 8;
    pdf.setFontSize(13);
    pdf.setFont(undefined, "bold");
    pdf.setTextColor(41, 128, 185);
    pdf.text("Total Pedido:", xLabel, yTotais);
    pdf.text(`R$ ${totalPedido.toFixed(2)}`, xValor, yTotais, { align: "right" });

    // ===== INFORMAÇÕES ADICIONAIS =====
    let yInfo = yTotais + 12;
    pdf.setFontSize(10);
    pdf.setTextColor(0);
    pdf.setFont(undefined, "normal");

    const infos = [
      ["Data de entrega:", formatarData(dataEntrega) || "-"],
      ["Ordem de Compra:", ordemCompra || "-"],
      ["Frete:", tipoFrete || "-"],
      ["Transportadora:", transportadora || "-"],
      ["Observação:", PRVE_OBS_PEDIDO || "-"],
    ];

    infos.forEach(([label, valor]) => {
      pdf.setFont(undefined, "bold");
      pdf.text(label, 10, yInfo);
      pdf.setFont(undefined, "normal");
      pdf.text(String(valor), 55, yInfo);
      yInfo += 6;
    });

    // ===== RODAPÉ =====
    yInfo += 6;
    pdf.setFontSize(9);
    pdf.setTextColor(150);
    pdf.setFont(undefined, "italic");
    pdf.text(
      "Este documento não tem validade como pedido, é apenas um orçamento.",
      pageWidth / 2,
      yInfo,
      { align: "center" }
    );

    pdf.save(`Orçamento-${(selectedCliente?.colFantasia || "cliente").replace(/\s+/g, "-")}-${hoje.replace(/\//g, "-")}`);
  };

  carregarImagem(logoUrl)
    .then((img) => montarPDF(img))
    .catch(() => montarPDF(null)); // se a logo falhar, gera o PDF sem ela
  };

  const formatarData = (dataISO) => {
  if (!dataISO) return '';
  const [ano, mes, dia] = dataISO.split('-');
  return `${dia}/${mes}/${ano}`;
  }

  const formatarDataComHora = (dataISO) => {
    if (!dataISO) return '';
    const d = new Date(dataISO);
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  const formatarDataBrasil = (dataISO) => {
    if (!dataISO) return '';
    const d = new Date(dataISO);
    return d.toLocaleDateString('pt-BR', { timeZone: 'UTC' });
  };

  const imprimirBoleto = async (creId, cliente) => {
      try {

        await fetch(`${userInfo.url}/receber/boleto/impressao/${creId}`, {
          method: "GET",
          headers: { empresa: userInfo.alias },
        });

        const pdfUrl = `${userInfo.url}/pdf/${userInfo.alias}/${selectedCliente.cliId}.pdf`;

        const response = await fetch(pdfUrl);
        const blob = await response.blob();
        
        const url = window.URL.createObjectURL(blob);
        
        const a = document.createElement('a');
        a.href = url;
        const agora = new Date();
        const dataHora = `${agora.getDate().toString().padStart(2, '0')}-${(agora.getMonth() + 1).toString().padStart(2, '0')}-${agora.getFullYear()}-${agora.getHours().toString().padStart(2, '0')}-${agora.getMinutes().toString().padStart(2, '0')}`;
        a.download = `Boleto-${cliente.colFantasia}-${dataHora}.pdf`;
        a.target = '_blank';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        
        window.URL.revokeObjectURL(url);
        
        
      } catch (err) {
        console.error(err);
        alert("Erro ao imprimir boleto");
      }
  };

const limparCampos = () => {
  setSelectedCliente(null);
  setOrder({});
  setOrderItems([]);
  setDesconto('');
  setTaxaEntrega('');
  setPaymentMethod('');
  setPaymentTerms([]);
  setDataEntrega('');
  setPRVE_OBS_PEDIDO('');
  setSearchTerm('');
  setDescontoBoleto('');
  setContadorOrdem(1);
  setInfoTabelaProduto({});
  setOrdemCompra('');
  setTipoFrete('');
  setTransportadora('');
  setRota(0);
  setTipoSal('');
  setPercentualSal('');
};

  const salvarOrcamento = () => {
    const orcamento = {
      id: Date.now(),
      cliente: selectedCliente,
      order: order,
      itens: orderItems,
      total: calcularTotalPedido(),
      desconto,
      taxaEntrega,
      paymentMethod,
      paymentTerms,
      dataEntrega,
      observacoes: PRVE_OBS_PEDIDO,
      dataCriacao: new Date().toISOString(),
      ordemCompra,
      tipoFrete,
      transportadora,
      rota,
      tipoSal,
      percentualSal,
      descontoBoleto
    };

    const orcamentos = JSON.parse(localStorage.getItem('orcamentos')) || [];
    orcamentos.push(orcamento);
    localStorage.setItem('orcamentos', JSON.stringify(orcamentos));
    
    alert('Orçamento salvo!');
    limparCampos();
  };

  const carregarOrcamentos = () => {
    return JSON.parse(localStorage.getItem('orcamentos')) || [];
  };

  const carregarOrcamento = (id) => {
    const orcamentos = carregarOrcamentos();
    const orcamento = orcamentos.find(o => o.id === id);
    
    if (orcamento) {
      setSelectedCliente(orcamento.cliente);
      setOrder(orcamento.order || {});
      setOrderItems(orcamento.itens);
      setDesconto(orcamento.desconto || '');
      setTaxaEntrega(orcamento.taxaEntrega || '');
      setPaymentMethod(orcamento.paymentMethod || '');
      setPaymentTerms(orcamento.paymentTerms || []);
      setDataEntrega(orcamento.dataEntrega || '');
      setPRVE_OBS_PEDIDO(orcamento.observacoes || '');
      setSearchTerm(orcamento.cliente?.colNome || '');
      setOrdemCompra(orcamento.ordemCompra || '');
      setTipoFrete(orcamento.tipoFrete || '');
      setTransportadora(orcamento.transportadora || '');
      setRota(orcamento.rota || 0);
      setTipoSal(orcamento.tipoSal || '');
      setPercentualSal(orcamento.percentualSal || '');
      setDescontoBoleto(orcamento.descontoBoleto || '');
      
      alert('Orçamento carregado!');
    }
  };

  const excluirOrcamento = (id) => {
    let orcamentos = carregarOrcamentos();
    orcamentos = orcamentos.filter(o => o.id !== id);
    localStorage.setItem('orcamentos', JSON.stringify(orcamentos));
    
    setOrcamentosSalvos(orcamentos);
    
    alert('Orçamento excluído!');
  };

  // 🆕 Limpar timers ao desmontar componente
  useEffect(() => {
    return () => {
      Object.values(validacaoTimers).forEach(timer => clearTimeout(timer));
    };
  }, [validacaoTimers]);

  // 🆕 Memoização de tipos de tripa, qualidade e calibres
  const tiposTripa = useMemo(
    () => [...new Set(
       (Array.isArray(produtos) ? produtos : [])
        .filter(p =>
          (!tipoQualidade || p.qualidade === tipoQualidade) &&
          (!calibre || p.calibre === calibre)
        )
        .map(p => p.tipo)
        .filter(Boolean)
    )],
    [produtos, tipoQualidade, calibre]
  );

  const tiposQualidade = useMemo(
    () => [...new Set(
       (Array.isArray(produtos) ? produtos : [])
        .filter(p =>
          (!tipoTripa || p.tipo === tipoTripa) &&
          (!calibre || p.calibre === calibre)
        )
        .map(p => p.qualidade)
        .filter(Boolean)
    )],
    [produtos, tipoTripa, calibre]
  );

  const calibres = useMemo(
    () => [...new Set(
      (Array.isArray(produtos) ? produtos : [])
        .filter(p =>
          (!tipoTripa || p.tipo === tipoTripa) &&
          (!tipoQualidade || p.qualidade === tipoQualidade)
        )
        .map(p => p.calibre)
        .filter(Boolean)
    )],
    [produtos, tipoTripa, tipoQualidade]
  );

  const handleTipoTripaChange = (e) => {
    const value = e.target.value;
    setTipoTripa(value);
    // valida se a qualidade/calibre atual ainda são compatíveis
    if (tipoQualidade && !produtos.some(p => p.tipo === value && p.qualidade === tipoQualidade)) {
      setTipoQualidade('');
    }
    if (calibre && !produtos.some(p => p.tipo === value && p.calibre === calibre)) {
      setCalibre('');
    }
  };

  const handleTipoQualidadeChange = (e) => {
    const value = e.target.value;
    setTipoQualidade(value);
    if (tipoTripa && !produtos.some(p => p.qualidade === value && p.tipo === tipoTripa)) {
      setTipoTripa('');
    }
    if (calibre && !produtos.some(p => p.calibre === value && p.calibre === calibre)) {
      setCalibre('');
    }
  };

  const handleCalibreChange = (e) => {
    const value = e.target.value;
    setCalibre(value);
    if (tipoTripa && !produtos.some(p => p.qualidade === value && p.tipo === tipoTripa)) {
      setTipoTripa('');
    }
    if (tipoQualidade && !produtos.some(p => p.calibre === value && p.qualidade === tipoQualidade)) {
      setTipoQualidade('');
    }
  };

  function formatarDataParaInputDate(valor) {
    if (!valor) return '';

    // Se já for string ISO: "2026-07-22T00:00:00" ou "2026-07-22"
    if (typeof valor === 'string' && valor.match(/^(\d{4})-(\d{2})-(\d{2})/)) {
      return valor.substring(0, 10); // pega só YYYY-MM-DD
    }

    // Se for string pt-BR: "22/07/2026"
    if (typeof valor === 'string' && valor.includes('/')) {
      const partes = valor.split('/');
      const dia = partes[0].padStart(2, '0');
      const mes = partes[1].padStart(2, '0');
      const ano = partes[2];
      return `${ano}-${mes}-${dia}`;
    }

    return '';
  }

  const dataMinima = () => {
    const hoje = new Date();
    hoje.setDate(hoje.getDate() + 3);
    return hoje.toISOString().split('T')[0];
  };


  const handleFileChange = (event) => {
    const selectedFiles = Array.from(event.target.files || []);
    if (selectedFiles.length === 0) return;

    setFiles(selectedFiles);

    const newPreviews = selectedFiles.map((f) =>
      f.type.startsWith('image/') ? URL.createObjectURL(f) : null
    );
    setPreviews(newPreviews);
  };

  const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(',')[1]); // remove "data:...;base64,"
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });

  const limparArquivos = () => {
    previews.forEach((p) => p && URL.revokeObjectURL(p));
    setFiles([]);
    setPreviews([]);
    setMessage('');
    setInputKey((k) => k + 1); // recria o input
  };

  const comprimirImagem = (file, maxLado = 1600, qualidade = 0.7) =>
    new Promise((resolve) => {
      if (!file.type.startsWith('image/')) return resolve(file);
      const img = new Image();
      img.onload = () => {
        const escala = Math.min(1, maxLado / Math.max(img.width, img.height));
        const canvas = document.createElement('canvas');
        canvas.width = img.width * escala;
        canvas.height = img.height * escala;
        canvas.getContext('2d').drawImage(img, 0, 0, canvas.width, canvas.height);
        URL.revokeObjectURL(img.src);
        canvas.toBlob(
          (b) => resolve(new File([b], file.name.replace(/\.\w+$/, '.jpg'), { type: 'image/jpeg' })),
          'image/jpeg',
          qualidade
        );
      };
      img.onerror = () => resolve(file);
      img.src = URL.createObjectURL(file);
    });

  const envioArquivo = async (novoPedidoId) => {
    if (!files.length) return true;

    let sucesso = 0;
    let falha = 0;

    for (let i = 0; i < files.length; i++) {
      setMessage(`Enviando ${i + 1} de ${files.length}...`);
      try {
        const arquivo = await comprimirImagem(files[i]);
        const body = [
          {
            DOC_DESCRICAO: arquivo.name,
            PRVE_ID: String(novoPedidoId),          
            nome_arquivo: arquivo.name,
            base64: await fileToBase64(arquivo)
          }
        ];

        const response = await fetch(`${userInfo.url}/documentos/upload`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'empresa': userInfo.alias,
            'Authorization': `Basic ${credentials}`,
          },
          body: JSON.stringify(body),
        });

        if (response.ok) sucesso++;
        else {
          console.error('Erro no upload:', response.status, await response.text());
          falha++;
        }
      } catch (error) {
        console.error('Erro na requisição:', error);
        falha++;
      }
    }

    if (falha === 0) {
      limparArquivos();
      setMessage(`✅ ${sucesso} arquivo(s) enviado(s) com sucesso!`);
    } else {
      setMessage(`⚠️ ${sucesso} enviado(s), ${falha} falharam.`);
    }
    return falha === 0;
  };

  return (
    <>
    {loadingPedidos ? (
      <div className="loading-container" tabIndex={-1}>
        <img src={logo} alt="Logo" className="loading-logo" />
        <p>Carregando dados, aguarde...</p>
      </div>
    ) : (
    <>
      <header className="header">
        <img src={logo} alt="Logo" className="header-logo" />
        <h2>Bem-vindo, {userInfo.username}!</h2>
        <h1>Pedido de Venda {userInfo.company}</h1>
      </header>

      <div className='top-bar'>
        <Link to="/menu" className="link-style">Voltar ao menu</Link>
        <button className="btnOrcamentos" onClick={() => {
          setOrcamentosSalvos(carregarOrcamentos());
          setShowOrcamentos(true);
        }}>Orçamentos Salvos</button>
      </div>

        <div className="containerOrcamento">
          {showOrcamentos && (
            <div className="modal-orcamentos">
              <h3>Orçamentos Salvos</h3>
              {orcamentosSalvos.map(orc => (
                <div key={orc.id} className="orcamento-item">
                  <span>{orc.cliente.colNome} - R$ {orc.total.toFixed(2)}</span>
                  <button className='btnCarregar' onClick={() => carregarOrcamento(orc.id)}>Carregar</button>
                  <button className='btnExcluir' onClick={() => excluirOrcamento(orc.id)}>Excluir</button>
                </div> 
              ))}
              <div>
                <button className='fecharOrcamentos' onClick={() => setShowOrcamentos(false)}>Fechar</button>
              </div>
            </div>
          )}
        </div>
        <div> 
      </div>       

      <div className="cliente-box">
        <input
          type="text"
          placeholder="Pesquisar cliente..."
          value={selectedCliente ? selectedCliente.colFantasia : searchTerm}
          onChange={(e) => {
            setSearchTerm(e.target.value);
            setSelectedCliente(null);
            setShowSuggestions(true);
          }}
          onFocus={() => setShowSuggestions(true)}
        />
          {searchTerm && (
            <button
              className="clear-button"
              title="Limpar pesquisa"
              onClick={() => {
                setSearchTerm('');
                setSelectedCliente(null);
                setShowSuggestions(false);
              }}
            >
              ❌
            </button>
          )}

          {showSuggestions && searchTerm && (
            <ul className="cliente-list">
              {filteredClientes.length > 0 ? (
                filteredClientes.map((c, index) => (
                  <li key={`${c.cliId}-${index}`} value={c.cliId} onClick={() => handleSelectCliente(c)}
                  >
                    {c.cliId} - <strong>{c.colNome}</strong> <br /> {c.colFantasia}
                  </li>
                ))
              ) : (
                <li>❌ Nenhum cliente encontrado</li>
              )}
            </ul>
          )}
      </div>

      {selectedCliente?.vencido === 'T' && (
        <form className="financeiroAtrasado">
          <h3>CLIENTE COM PENDÊNCIAS FINANCEIRAS!</h3>
        </form>
      )}
      {selectedCliente && (
        <div className="cliente-info-principal">
            <span><strong>Razão:</strong> {selectedCliente.colNome}</span>
            <span><strong>Limite de Crédito:</strong> {
            (selectedCliente.cliLimiteCredito ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})
            }</span>
            <span><strong>Limite disponível:</strong> {
              (selectedCliente.limiteDisponivel ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})
            }</span>            
        </div>
      )}
      <div className="btnCarrinhoContainer">
        {selectedCliente && (
          <div className="cliente-info">
            <button className='btnExpandir' onClick={() => setShowClienteInfo(prev => !prev)}>
              {showClienteInfo ? '− Ocultar' : '+ Mostrar'} informações do cliente
            </button>
            {showClienteInfo && (
              <>
                <div className="cliente-det"> 
                  
                  
                  <div className="cliente-detalhes">

                    <button className='btnFecharShowCliente' onClick={() => setShowClienteInfo(prev => !prev)}>X</button>

                    <span><strong>CNPJ/CPF:</strong> {selectedCliente.colCnpjCpf}</span>
                    <span><strong>Inscrição Estadual:</strong> {selectedCliente.colInscricaoEstadual}</span>
                    <span><strong>Endereço:</strong> {selectedCliente.endRua}, {selectedCliente.endNumero}</span>
                    <span><strong>Complemento:</strong> {selectedCliente.endComplemento}</span>
                    <span><strong>Cidade:</strong> {selectedCliente.endCidade}</span>
                    <span><strong>UF:</strong> {selectedCliente.endEstado}</span>
                    <span><strong>CEP:</strong> {selectedCliente.endCep}</span>
                    <span><strong>Email:</strong> {selectedCliente.colEmail}</span>
                    <span><strong>Contato:</strong> {selectedCliente.colContato}</span>
                    <span><strong>Fone1:</strong> {selectedCliente.colFone1}</span>
                    <span><strong>Fone2:</strong> {selectedCliente.colFone2}</span>
                    <span ><strong>Whats:</strong> {selectedCliente.colCelularWhatsapp} </span>
                    <span><strong>Forma de Pagamento:</strong> {selectedCliente.pagDescricao}</span>
                    <span><strong>Prazo de Pagamento:</strong> {selectedCliente.prazo}</span>
                    <span><strong>Limite de Crédito:</strong> R$ {selectedCliente.cliLimiteCredito.toFixed(2)}<strong> - Limite Disponível: R$ {(selectedCliente.limiteDisponivel).toFixed(2)}</strong></span>
                    
                  </div> 

                  <div className="cliente-detalhes">
                    <button
                        className={abaInfoCliente === 'financeiro' ? 'aba-ativa' : ''}
                        onClick={() => setAbaInfoCliente('financeiro')}
                      >
                        💰 Financeiro
                      </button>
                      <button
                        className={abaInfoCliente === 'pedidos' ? 'aba-ativa' : ''}
                        onClick={() => {
                          setAbaInfoCliente('pedidos');
                          buscarPedidosCliente(selectedCliente.cliId);
                        }}
                      >
                        📦 Pedidos Anteriores
                      </button>
                  </div>

                  <div>
                    {abaInfoCliente === 'financeiro' && financeiroAtrasado.length > 0 && (
                      <div className="financeiro-lista">
                        <h4>Financeiro em Aberto</h4>
                        <table>
                          <thead>
                            <tr>
                              <th>Vencimento</th>
                              <th>Pedido</th>
                              <th>Valor</th>
                              <th>Título/Parcela</th>
                              <th>🖨️ Boleto</th>
                            </tr>
                          </thead>
                          <tbody>
                            {financeiroAtrasado.map((item, i) => (
                              <tr key={i}>
                                <td>{formatarDataComHora(item.creDtaVencimento)}</td>
                                <td>{item.nfePedido}</td>
                                <td>{item.creVlrReceber}</td>
                                <td>{item.creTitulo}-{item.creParcela}</td>
                                <td>{item.crePagamento === 'BOLETO' && (
                                  <button className='impBoleto' onClick={() => imprimirBoleto(item.creId, selectedCliente)}>🧾</button>
                                )}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    )}

                    {abaInfoCliente === 'pedidos' && (
                      <div className="pedidos-cliente-lista">
                        <h4>Pedidos Anteriores</h4>
                        {!loadingPedido && pedidoData.length > 0 ? (
                          <>
                            <table className="Pedido-grid">
                              <thead>
                                <tr>
                                  <th>Pedido</th>
                                  <th>Nota</th>
                                  <th>Cadastro</th>
                                  <th>Emissão</th>
                                  <th>Status</th>
                                  <th>Total Produtos</th>
                                  <th>Total Nota</th>
                                  <th>Itens</th>
                                </tr>
                              </thead>
                                <tbody>
                                  {pedidoData.map((item, idx) => (
                                    <Fragment key={idx}>
                                      {/* Linha principal do pedido */}
                                      <tr className={nfeSelecionada === item.nfeId ? 'linha-ativa' : ''}>
                                        <td>{item.nfeId}</td>
                                        <td>{item.nfeNota}</td>
                                        <td>{formatarDataBrasil(item.nfeDtaCadastro) || ''}</td>
                                        <td>{formatarDataBrasil(item.nfeDtaEmissao) || ''}</td>
                                        <td>{item.nfeStatus}</td>
                                        <td>{item.nfeTotMercadoria.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                        <td>{item.nfeTotNota.toLocaleString("pt-BR", { style: "currency", currency: "BRL" })}</td>
                                        <td>
                                          <button
                                            className='btn-itens'
                                            title={nfeSelecionada === item.nfeId ? "Fechar itens" : "Ver itens do pedido"}
                                            onClick={() => buscarItensPedido(item.nfeId)}
                                          >
                                            {nfeSelecionada === item.nfeId ? '−' : "+" }
                                          </button>
                                        </td>
                                      </tr>

                                      {/* Linha expandida com os itens, logo abaixo da linha clicada */}
                                      {nfeSelecionada === item.nfeId && (
                                        <tr className="linha-itens">
                                          <td colSpan={9}>
                                            {loadingItens ? (
                                              <p className="carregando-itens">Carregando itens...</p>
                                            ) : itensPedido.length > 0 ? (
                                              <table className="itens-grid">
                                                <thead>
                                                  <tr>
                                                    <th>Código</th>
                                                    <th>Descrição</th>
                                                    <th>Qtde</th>
                                                    <th>Vlr. Unit.</th>
                                                    <th>Vlr. Total</th>
                                                  </tr>
                                                </thead>
                                                <tbody>
                                                  {itensPedido.map((item, i) => (
                                                    <tr key={i}>
                                                      <td>{item.proCodInterno ?? ''}</td>
                                                      <td>{item.proDescricao ?? ''}</td>
                                                      <td>{item.infeQtdProduto}</td>
                                                      <td>{Number(item.infeVlrProduto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                      <td>{(Number(item.infeQtdProduto) * Number(item.infeVlrProduto)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                                    </tr>
                                                  ))}
                                                </tbody>
                                              </table>
                                            ) : (
                                              <p className="sem-itens">❌ Nenhum item encontrado</p>
                                            )}
                                          </td>
                                        </tr>
                                      )}
                                    </Fragment>
                                  ))}
                                </tbody>

                            </table>
                          </>
                        ) : !loadingPedido && (
                          <p>❌ Nenhum registro encontrado</p>
                        )}
                      </div>
                    )}
                  </div>

                </div>
              </>
            )}
          </div>
        )}
      </div>

      {!selectedCliente ? (
        <div className="pedido-box">
          <h3>Selecione um Cliente para mostrar os produtos.</h3>
        </div>
      ) : (
        <div className='infoAdicionalPedido'>
          <div className='infoaddSuperiror'>
            {userInfo.descontoPedido === "T" && (<input
              className='descontoPedido'
              placeholder='R$ Desconto Pedido'
              type='text'
              value={desconto || ''}
              onChange={(e) => setDesconto(e.target.value)}
            />)}
            {userInfo.descontoFinanceiro === "T" && (<input
              className='descontoPedido'
              placeholder='R$ Desconto Boleto'
              type='text'
              value={descontoBoleto || ''}
              onChange={(e) => setDescontoBoleto(e.target.value)}
            />)}

            {userInfo.taxaEntrega === "T" && (<input
              className='descontoPedido'
              placeholder='R$ Vlr do Frete'
              type='text'
              value={taxaEntrega || ''}
              onChange={(e) => setTaxaEntrega(e.target.value)}
            />)}

            
            <div className='dataEntraga'>
              <label>Ordem de Compra:</label>
              <input
                className='descontoPedido'
                placeholder='Ordem de compra'
                type='text'
                value={ordemCompra || ''}
                onChange={(e) => setOrdemCompra(e.target.value)}
              />
            </div>
            
            <div className='dataEntraga'>
              <label>Tipo de Frete:</label>
              <select
                className='descontoPedido'
                value={tipoFrete}
                onChange={(e) => setTipoFrete(e.target.value)}
              >
                <option value=''>Frete</option>
                <option value='PAGO'>FOB (PAGO)</option>
                <option value='A PAGAR'>CIF (A PAGAR)</option>
                <option value='PROPRIO REMETENTE'>CAMINHÃO TS</option>
                <option value='PROPRIO DESTINATARIO'>RETIRA (CARRO CLIENTE)</option>
              </select>
            </div>

            {tipoFrete === 'PROPRIO REMETENTE' && (
              <div className='dataEntraga'>
                <label>Rota:</label>
                <select
                  className='descontoPedido'
                  value={rota || 0}
                  onChange={(e) => {
                    const rotaId = e.target.value;
                    setRota(rotaId);

                    if (!rotaId) {
                      setDataEntrega('');
                      return;
                    }

                    const rotaSelecionada = listaRotas.find(
                      (item) => String(item.rotaId) === String(rotaId)
                    );

                    console.log('Rota selecionada:', rotaSelecionada);

                    if (rotaSelecionada?.rotaDtaSaida) {
                      const dataFormatada = formatarDataParaInputDate(rotaSelecionada.rotaDtaSaida);
                      console.log('Data formatada para input:', dataFormatada);
                      setDataEntrega(dataFormatada);
                    }
                  }}
                >
                  <option value='0'>Selecione uma rota</option>
                  {listaRotas.map((item) => {
                    // Extrai a data como string, sem fuso horário
                    let dataExibicao = 'Sem data';
                    if (item.rotaDtaSaida) {
                      const match = String(item.rotaDtaSaida).match(/^(\d{4})-(\d{2})-(\d{2})/);
                      if (match) {
                        dataExibicao = `${match[3]}/${match[2]}/${match[1]}`;
                      }
                    }

                    return (
                      <option key={item.rotaId} value={item.rotaId}>
                        {item.rotaDescricao} - {dataExibicao}
                      </option>
                    );
                  })}
                </select>
              </div>
            )}

            {(tipoFrete === 'PAGO' || tipoFrete === 'A PAGAR') && (
              <>
                <div className='dataEntraga'>
                  <label>Transportadora:</label>
                  <input
                    className='descontoPedido'
                    placeholder='Digite a transportadora'
                    value={transportadora}
                    onChange={(e) => setTransportadora(e.target.value)}
                  />
                </div>
               </>
            )}

            {(tipoFrete === 'PAGO' || tipoFrete === 'A PAGAR' || tipoFrete === 'PROPRIO DESTINATARIO') && 
                <div className='dataEntraga'>
                  <label>Data de entrega:</label>
                  <input
                    className='dtaEntrega'
                    type='date'
                    required={userInfo.obrigatotiodataentrega === 'T'}
                    value={dataEntrega || ''}
                    min={dataMinima()}
                    onChange={(e) => setDataEntrega(e.target.value)}
                  />
                </div>
            }
             

            <div className='dataEntraga'>
              <label>Tipo de sal:</label>
              <select
                className='descontoPedido'
                value={tipoSal}
                onChange={(e) => setTipoSal(e.target.value)}
              >
                <option value=''>Tipo de Sal</option>
                <option value='FINO'>Sal Fino</option>
                <option value='GROSSO'>Sal Grosso</option>
              </select>
            </div>

            {tipoSal === 'FINO' && (
              <div className='dataEntraga'>
                <label>Percentual de Sal:</label>
                <select
                  className='descontoPedido'
                  value={percentualSal}
                  onChange={(e) => setPercentualSal(e.target.value)}
                >
                  <option value=''>Percentual de Sal</option>
                  <option value='50'>50%</option>
                  <option value='60'>60%</option>
                  <option value='70'>70%</option>
                  <option value='80'>80%</option>
                  <option value='90'>90%</option>
                </select>
              </div>
            )}

          </div>

          <div className='dataEntraga'>
            <label>Observação:</label>
            <textarea
              className='obsPedido'
              value={PRVE_OBS_PEDIDO}
              onChange={(e) => setPRVE_OBS_PEDIDO(e.target.value)}
            />
          </div>

          <div style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '8px' }}>
            <label htmlFor="file-upload" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
              Selecione o arquivo ou tire a foto para este pedido:
            </label>
            <input
              key={inputKey}
              id="file-upload"
              type="file"
              multiple
              accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
              onChange={handleFileChange}
            />

            {message && <p style={{ fontSize: '13px', color: '#007bff', marginTop: '5px' }}>{message}</p>}

            {files.length > 0 && (
              <div style={{ marginTop: '15px' }}>
                <p style={{ fontSize: '14px', margin: '5px 0' }}>Arquivos selecionados ({files.length}):</p>
                {files.map((f, idx) => (
                  <div key={idx} style={{ marginBottom: '8px' }}>
                    {previews[idx] ? (
                      <img
                        src={previews[idx]}
                        alt={`Preview ${idx}`}
                        style={{ width: '100%', maxHeight: '150px', objectFit: 'contain', borderRadius: '8px' }}
                      />
                    ) : (
                      <p style={{ fontSize: '14px', color: '#555' }}>📄 {f.name}</p>
                    )}
                  </div>
                ))}
              </div>
            )}
          </div>      
        </div>
      )}

      {selectedCliente && (
        <div className="payment-box"> 
          <h3>💳 Condições de Pagamento</h3>

          <select value={paymentMethod} onChange={(e) => setPaymentMethod(e.target.value.toUpperCase())} disabled={userInfo.edicaoPrazoPagamento === 'T'}>
            <option value="">Selecione...</option>
            <option value="BOLETO">Boleto</option>
            <option value="PIX">Pix</option>
          </select>

          <div className="terms-container">
            {paymentTerms.map((term, idx) => (
              <input
                key={idx}
                type="number"
                min={1}
                disabled={userInfo.edicaoPrazoPagamento === 'T'}
                placeholder={`Parc. ${idx + 1}`}
                value={term}
                onChange={(e) => handleTermChange(idx, e.target.value)}
                onBlur={(e) => handleTermBlur(idx, e.target.value)}
              />
            ))}
          </div>
        </div>
      )}

      {selectedCliente && (
          <>
        <div className="btnCarrinhoContainer">
          <button className='btnCarrinho' onClick={confirmarPedido}>🛒 {(calcularTotalPedido() ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</button>  
        </div>
          
        <div className="filtros">
          <input
            type="text"
            className='pesqProdVenda'
            placeholder="Filtrar produtos por nome ou código..."
            value={searchProduto}
            onChange={(e) => setSearchProduto(e.target.value)}
          />
          
          <select className="tipoTripa" value={tipoTripa} onChange={handleTipoTripaChange}>
            <option value="">Todos os tipos</option>
            {tiposTripa.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>

          <select className="tipoTripa" value={tipoQualidade} onChange={handleTipoQualidadeChange}>
            <option value="">Tipo de Qualidade</option>
            {tiposQualidade.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>

          <select className="tipoTripa" value={calibre} onChange={handleCalibreChange}>
            <option value="">Tipo de Calibre</option>
            {calibres.map((item) => (
              <option key={item} value={item}>{item}</option>
            ))}
          </select>

          <button className="btnLimparFiltros" onClick={() => {
            setTipoTripa('');
            setTipoQualidade('');
            setCalibre('');
          }}>Limpar Filtros</button>
        </div>

        <div className="tabs">
          <button onClick={() => setAbaSelecionada("Produtos")}>Produtos</button>
          <button disabled={!selectedCliente} onClick={() => setAbaSelecionada("Mix")}>Mix</button>
          <div className='checkbox-container'>
            <Checkbox
              className="produtos do pedido"
              checked={apenasComQuantidade}
              onChange={() => setApenasComQuantidade(prev => !prev)}
            />
            <label className="checkbox-label">Exibir apenas produtos adicionados no pedido</label>
          </div>

        </div>
            
        <div>
          {abaSelecionada === "Produtos" && (
            <div className="container">
            {(Array.isArray(produtosFiltrados) ? produtosFiltrados : [])
              .filter(p => !tipoTripa || p.tipo === tipoTripa)
              .filter(p => !tipoQualidade || p.qualidade === tipoQualidade)
              .filter(p => !calibre || p.calibre === calibre)
              .filter(p => !apenasComQuantidade || (order[p.tabId]?.quantidade > 0))
              .map((p) => {
                const dados = order[p.tabId] || {};
                const precoItem = dados.preco ?? p.vlrVenda;
          
                // 🆕 Info da tabela aplicada
                const infoTabela = infoTabelaProduto[p.tabId] || "";
          
                return (
                  <div key={p.tabId} className="product-item">
                    <div>
                      <span className="linha-superior"><strong>{p.descricao}</strong></span>

                    </div>
                    <div className="quantity-controls">
                      <label>Qtd:</label>
                      <NumericInput
                        className="inputValores"
                        value={dados.quantidade}
                        decimals={3}
                        disabled={selectedCliente?.vencido === "T" && userInfo?.bloqFinanceiro === "T"}
                        onChangeRaw={(raw) => handleQuantityChange(p.tabId, raw)}
                        onBlurNumber={(num) => {
                          setOrder((prev) => ({
                            ...prev,
                            [p.tabId]: {
                              ...prev[p.tabId],
                              quantidade: num,
                            },
                          }));
                        }}
                      />
                        
                      <label>Preço:</label>
                      <NumericInput
                        className="inputValores"
                        value={dados.preco ?? p.vlrVenda}
                        decimals={2}
                        onChangeRaw={raw => {
                          const preco = parseFloat(raw);
                          const precoFormatado = isNaN(preco) ? 0 : parseFloat(preco.toFixed(2));
                          handlePriceChange(p.tabId, precoFormatado);
                        }}
                      />

                      <label>Total:</label>
                      <input
                        className="inputValores"
                        type="number"
                        step="0.01"
                        value={(precoItem * (dados.quantidade || 0)).toFixed(2)}
                        disabled
                      />

                      <div className='camposComplementar'> 
                        <input 
                          className='descricaoComplementar'
                          type='text'
                          placeholder='Complemento'
                          value={dados.descricaoComplementar || ''}
                          onChange={(e) => {
                            const valor = e.target.value;
                            setOrder(prev => ({
                              ...prev,
                              [p.tabId]: {
                                ...prev[p.tabId],
                                descricaoComplementar: valor
                              }
                            }));
                          }}
                        />
                      </div>
                    </div>

                    <label className='medidaObrigatoria'>
                      <Checkbox
                        checked={aceitaOutraMedida(dados)}
                        onChange={(e) => {
                          const valor = e.target.checked;
                          setOrder(prev => ({
                            ...prev,
                            [p.tabId]: {
                              ...prev[p.tabId],
                              aceitaOutraMedida: valor,
                            },
                          }));
                        }}
                      />
                      <span>Cliente aceita outras metragens de maço.</span>
                    </label>

                    <div>
                        {/* 🆕 Exibir mensagem de validação de preço */}
                      {infoTabela && (
                      <div className={`validacao-preco ${infoTabela.includes('✅') ? 'valido' : 'invalido'}`}>
                        {infoTabela}
                      </div>
                      )}
                    </div>
                    
                  </div>
                );
              })}
            </div>
          )}

          {abaSelecionada === "Mix" && (
            loadingPedidos ? (
              <p className='loadingMix'>Carregando dados, aguarde...</p>
            ) : mixProdutos.length > 0 ? (
              <div className='container'>
                {mixProdutos
                .filter(p => !apenasComQuantidade || (order[p.tabId]?.quantidade > 0))
                .map((p, index) => {
                  const dados = order[p.tabId] || {};
                  const precoItem = dados.preco ?? p.vlrVenda;
                  
                  // 🆕 Info da tabela aplicada
                  const infoTabela = infoTabelaProduto[p.tabId] || "";

                  return (
                    <div key={p.tabId} className="product-item"> 
                      <div className='cabProd'>
                        <span><strong>{p.descricao}</strong></span>
                        <span>Último valor: 💰 {(p.vlrUltVenda ?? 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</span>
                        <span>📦 Qtd última compra: {p.qtdPeriodo}</span>
                      </div>
                      <div className="quantity-controls">
                        
                        <label>Qtd:</label>
                        <NumericInput
                          value={dados.quantidade ?? ""}
                          decimals={3}
                          onChangeRaw={(raw) => handleQuantityChange(p.tabId, raw)}
                          onBlurNumber={(quantidade) => {
                            setOrder((prev) => ({
                              ...prev,
                              [p.tabId]: {
                                ...prev[p.tabId],
                                quantidade: parseFloat(quantidade.toFixed(3)),
                              },
                            }));
                          }}
                        />

                        <label>Preço:</label>
                        <NumericInput
                          value={dados.preco ?? p.vlrVenda}
                          decimals={2}
                          onChangeRaw={raw => {
                            const preco = parseFloat(raw);
                            const precoFormatado = isNaN(preco) ? 0 : parseFloat(preco.toFixed(2));
                            handlePriceChange(p.tabId, precoFormatado);
                          }}
                        />

                        <label>Total:</label>
                        <input
                          type="number"
                          step="0.01"
                          value={(precoItem * (dados.quantidade || 0)).toFixed(2)}
                          disabled
                        />
                        
                        <div className='camposComplementar'> 
                          <input 
                            className='descricaoComplementar'
                            type='text'
                            placeholder='Complemento'
                            value={dados.descricaoComplementar || ''}
                            onChange={(e) => {
                              const valor = e.target.value;
                              setOrder(prev => ({
                                ...prev,
                                [p.tabId]: {
                                  ...prev[p.tabId],
                                  descricaoComplementar: valor
                                }
                              }));
                            }}
                          />
                        </div>

                      <label className='medidaObrigatoria'>
                        <Checkbox
                          checked={aceitaOutraMedida(dados)}
                          onChange={(e) => {
                            const valor = e.target.checked;
                            setOrder(prev => ({
                              ...prev,
                              [p.tabId]: {
                                ...prev[p.tabId],
                                aceitaOutraMedida: valor,
                              },
                            }));
                          }}
                        />
                        <span>Cliente aceita outras metragens de maço.</span>
                      </label>

                      </div> 
   
                      <div>
                        {/* 🆕 Exibir mensagem de validação de preço */}
                        {infoTabela && (
                        <div className={`validacao-preco ${infoTabela.includes('✅') ? 'valido' : 'invalido'}`}>
                          {infoTabela}
                        </div>
                        )}
                      </div>

                    </div>
                  );
                })}
              </div>
              ) : !loadingPedidos ? (
                <p className='loadingMix'>❌ Nenhum Produto do Mix encontrado!</p>
              ) : null
          )}
        </div>
      </>
    )}

      <div className="btnCarrinhoContainer"> 
        <button className='btnCarrinho' onClick={confirmarPedido}>🛒 Conferir Carrinho</button>
      </div>

      {showModal && (
        <div className="modal">
          <div className="modal-content">
          <img src={logo} alt="Logo" className="loading-logo" />
            <h2>Orçamento</h2>
            {(selectedCliente.limiteDisponivel - calcularTotalModal() || 0) < selectedCliente.cliLimiteCredito && (
                <span style={{ color: 'red', fontSize: '20px' }}>
                  <strong>
                    ⚠️ Limite de crédito do cliente excedido! Limite disponível: {selectedCliente.limiteDisponivel.toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}
                  </strong>
                </span>
              )}
            <div className='dadosClienteModal'>
              <span><strong>Dados do cliente: </strong>{selectedCliente.colFantasia}</span>
              <span><strong>Pagamento: </strong>{paymentMethod}</span>
              <div>
                <strong>Parcelas: </strong>
                {paymentTerms
                  .filter((d) => d !== undefined && d !== null && d !== '')
                  .map((dias, index) => {
                    
                    return (
                      <span key={index}>
                        {dias} dias
                        {index < paymentTerms.filter(t => t && t !== '').length - 1 && ' , '}
                      </span>
                      
                    );
                  })
                }
              </div>
            </div>
            <div className='blocoItensModal'>
              <h4>Produtos:</h4>
              <ul>
                {orderItems
                  .sort((a, b) => a.ordem - b.ordem)
                  .map((i, idx) => {
                    // 🆕 Info da tabela aplicada
                    const infoTabela = infoTabelaProduto[i.tabId] || "";

                    return(
                    <li key={idx} className='listaProdModal'>
                      <div className='descricaoProdModal'>
                        <span>
                          {i.descricao} {i.IPRV_DESC_COMPLEMENTAR}
                        </span>
                        <p>
                        <strong><span>Cliente aceita outras metragem de maço: {i.IPRV_OUTRA_MEDIDA === 'T' ? 'Sim ✅' : 'Não'}</span></strong>
                        </p>
                      </div>

                      <div className='qtdPrecoModal'>
                        <div className='inputModalCab'>
                          <span>{i.IPRV_UNIDADE}</span>
                          <input
                            className='inputModal'
                            type="number"
                            value={i.IPRV_QTD_PRODUTO}
                            onChange={(e) => handleModalItemChange(idx, 'IPRV_QTD_PRODUTO', parseFloat(e.target.value) || 0)}
                          />
                        </div>

                        <div className='inputModalCab'>
                          <span>R$</span>
                          <input
                            className='inputModal'
                            type="number"
                            step="0.01"
                            value={(i.IPRV_VLR_PRODUTO).toFixed(2)}
                            onChange={(e) => handleModalItemChange(idx, 'IPRV_VLR_PRODUTO', parseFloat(e.target.value) || 0)}
                          />
                        </div>
                      </div>
                      <strong><span>Total R$ {((i.IPRV_QTD_PRODUTO || 0) * (i.IPRV_VLR_PRODUTO || 0)).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</span></strong>
                      <div>
                          {/* 🆕 Exibir mensagem de validação de preço */}
                        {infoTabela && (
                        <div className={`validacao-preco ${infoTabela.includes('✅') ? 'valido' : 'invalido'}`}>
                          {infoTabela}
                        </div>
                        )}
                      </div>
                    </li>
                  )}
                )}
              </ul>
            <div className='infoPedidoModal'>
              <h3 className='total'>Sub Total: {(calcularTotalModal()).toLocaleString("pt-BR", {style: "currency", currency: "BRL",}) || 0}</h3>
              {userInfo.descontoPedido === "T" && (<p className='subtotal'>Desconto Pedido: {(parseFloat(desconto) || 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</p>)}
              {userInfo.descontoFinanceiro === "T" && (<p className='subtotal'>Desconto Boleto: {(parseFloat(descontoBoleto) || 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</p>)}
              {userInfo.taxaEntrega === "T" && (<p className='subtotal'>Taxa Entrega: {(parseFloat(taxaEntrega) || 0).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</p>)}
              <h3 className='total'>Total Pedido: {(calcularTotalModal() - Number(desconto || 0) + Number(taxaEntrega || 0)).toLocaleString("pt-BR", {style: "currency", currency: "BRL",})}</h3>
              <span><strong>Data de entrega: </strong> {formatarData(dataEntrega) || ''}</span>
              <span><strong>Ordem de Compra: </strong> {(ordemCompra) || ''}</span>
              <span><strong>Frete: </strong> {(tipoFrete) || ''}</span>
              <span><strong>Transportadora: </strong> {(transportadora) || ''}</span>
              <span><strong>Tipo de Sal: </strong> SAL {(tipoSal) || ''} - {percentualSal || ''}%</span>
              <span><strong>Observação: </strong> {(PRVE_OBS_PEDIDO || '.')}</span>
              <div style={{ marginBottom: '15px', padding: '10px', border: '1px solid #eee', borderRadius: '8px' }}>
                <label htmlFor="file-upload" style={{ display: 'block', marginBottom: '5px', fontWeight: 'bold' }}>
                  Selecione o arquivo ou tire a foto para este pedido:
                </label>
                <input
                  key={inputKey}
                  id="file-upload"
                  type="file"
                  multiple
                  accept="image/*,application/pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                  onChange={handleFileChange}
                />

                {message && <p style={{ fontSize: '13px', color: '#007bff', marginTop: '5px' }}>{message}</p>}

                {files.length > 0 && (
                  <div style={{ marginTop: '15px' }}>
                    <p style={{ fontSize: '14px', margin: '5px 0' }}>Arquivos selecionados ({files.length}):</p>
                    {files.map((f, idx) => (
                      <div key={idx} style={{ marginBottom: '8px' }}>
                        {previews[idx] ? (
                          <img
                            src={previews[idx]}
                            alt={`Preview ${idx}`}
                            style={{ width: '100%', maxHeight: '150px', objectFit: 'contain', borderRadius: '8px' }}
                          />
                        ) : (
                          <p style={{ fontSize: '14px', color: '#555' }}>📄 {f.name}</p>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>  
              <h4 className='alertaPDF'>Este documento não tem validade como pedido, é apenas um orçamento.</h4>
            </div>
            </div>
            <div className="modal-buttons no-print">
              <button className='btnVoltar' onClick={() => setShowModal(false)}>Voltar</button>
              <button className='btnPDF' onClick={gerarPDF}>🖨️ PDF</button>
              <button className='btnOrcamento' onClick={() => {salvarOrcamento(); setShowModal(false);}}>Salvar Orçamento</button>
              <button
                className='btnConfirmar'
                onClick={enviarPedido}
                disabled={isSubmitting}
              >
                {isSubmitting ? "Enviando Pedido" : "Enviar Pedido"}
              </button>
            </div>
          </div>
          {etapa && (
            <div className="overlay-status">
              {etapa === 'salvando' && (<><div className="spinner" /><p>Salvando Pedido...</p></>)}

              {etapa === 'cadastrado' && (
                <>
                  <svg className="check" viewBox="0 0 52 52">
                    <circle className="check-circle" cx="26" cy="26" r="24" fill="none" />
                    <path className="check-mark" fill="none" d="M14 27l8 8 16-16" />
                  </svg>
                  <p>Pedido cadastrado!</p>
                </>
              )}

              {etapa === 'enviando' && (<><div className="spinner" /><p>{message || 'Enviando arquivos...'}</p></>)}

              {etapa === 'concluido' && (
                <>
                  <svg className="check" viewBox="0 0 52 52">
                    <circle className="check-circle" cx="26" cy="26" r="24" fill="none" />
                    <path className="check-mark" fill="none" d="M14 27l8 8 16-16" />
                  </svg>
                  <p>Tudo pronto!</p>
                </>
              )}

              {etapa === 'erro' && <p>❌ Erro ao salvar Pedido. Tente novamente.</p>}
            </div>
          )}
        </div>
      )}
    </>
    )}
  </>
  );
};

export default Venda;